import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-tools" }
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "card-body row" }
const _hoisted_19 = { class: "form-group col-12 col-md-6" }
const _hoisted_20 = { for: "idCustomer" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "form-group col-12 col-md-6" }
const _hoisted_24 = { for: "name" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_26 = { class: "form-group col-12 col-md-6" }
const _hoisted_27 = { for: "email" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_29 = { class: "form-group col-12 col-md-6" }
const _hoisted_30 = { for: "username" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_32 = { class: "form-group col-12 col-md-6" }
const _hoisted_33 = { for: "password" }
const _hoisted_34 = { class: "input-group input-group-sm" }
const _hoisted_35 = ["type"]
const _hoisted_36 = { class: "input-group-append" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "form-group col-12 col-md-6" }
const _hoisted_40 = { for: "type" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_42 = { value: "" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "form-group col-12 col-md-6" }
const _hoisted_45 = { for: "enabled" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = { class: "card-footer text-center" }
const _hoisted_48 = { class: "btn-group" }

export function render(_ctx, _cache) {
  const _component_Toggle = _resolveComponent("Toggle")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.users")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.users")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t("labels.buttons.new")), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: _ctx.$t('labels.buttons.goBack')
              }, _hoisted_17, 8, _hoisted_15)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.customer")) + " ", 1),
                _hoisted_21
              ]),
              _withDirectives(_createElementVNode("select", {
                id: "idCustomer",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.row.idCustomer) = $event)),
                style: {"width":"auto","max-width":"-webkit-fill-available"},
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.idCustomer }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (i, k) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: i.id,
                    key: k
                  }, _toDisplayString(i.description), 9, _hoisted_22))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.row.idCustomer]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.idCustomer), 513), [
                [_vShow, _ctx.errors.idCustomer != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.name")) + " ", 1),
                _hoisted_25
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "name",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.row.name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.name }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.name]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.name), 513), [
                [_vShow, _ctx.errors.name != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.email")) + " ", 1),
                _hoisted_28
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.row.email) = $event)),
                type: "email",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.email }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.email]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.email), 513), [
                [_vShow, _ctx.errors.email != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.username")) + " ", 1),
                _hoisted_31
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "username",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.row.username) = $event)),
                type: "email",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.username}]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.username]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.username), 513), [
                [_vShow, _ctx.errors.username != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('labels.entity.password')), 1),
              _createElementVNode("div", _hoisted_34, [
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.row.password) = $event)),
                  type: _ctx.Password ? 'text' : 'password',
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.password}]),
                  maxlength: "200"
                }, null, 10, _hoisted_35), [
                  [_vModelDynamic, _ctx.row.password]
                ]),
                _createElementVNode("span", _hoisted_36, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info btn-flat",
                    onClick: _cache[6] || (_cache[6] = $event => (_ctx.togglePasswordVisibility()))
                  }, _hoisted_38)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("label", _hoisted_40, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.type")) + " ", 1),
                _hoisted_41
              ]),
              _withDirectives(_createElementVNode("select", {
                id: "type",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.row.type) = $event)),
                style: {"width":"auto","max-width":"-webkit-fill-available"},
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.type }])
              }, [
                _createElementVNode("option", _hoisted_42, _toDisplayString(_ctx.$t("labels.select")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (i, k) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: i.id,
                    key: k
                  }, _toDisplayString(i.description), 9, _hoisted_43))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.row.type]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.type), 513), [
                [_vShow, _ctx.errors.type != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t("labels.entity.active")), 1),
              _hoisted_46,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.enabled,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.row.enabled) = $event)),
                "on-label": _ctx.$t('labels.yes'),
                "off-label": _ctx.$t('labels.no')
              }, null, 8, ["modelValue", "on-label", "off-label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-sm btn-warning",
                onClick: _cache[9] || (_cache[9] = $event => (_ctx.goBack()))
              }, _toDisplayString(_ctx.$t("labels.buttons.cancel")), 1),
              _createElementVNode("button", {
                type: "button",
                id: "gravarButton",
                class: "btn btn-sm btn-success",
                onClick: _cache[10] || (_cache[10] = $event => (_ctx.save()))
              }, _toDisplayString(_ctx.$t("labels.buttons.save")), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}